import React from 'react'
import '@icon-park/react/styles/index.css'
import '@/assets/styleSheet/f2eColumLayout.less'
import '@/assets/styleSheet/common.less'
import 'antd/dist/antd.css'

const Layout: React.FC = ({ children }) => {
  return (
    <>
      <main style={{ padding: '12px' }}>{children}</main>
    </>
  )
}

export default Layout
